<template lang="html">
  <div :class="{isRed: linkRed}">
    <label for="permission" class="permission-check-label">
      Ja, tak Falck (Falck Assistance A/S og Falck Danmark A/S) må gerne kontakte mig via brev, telefon og elektronisk post (herunder sms og e-mail) om rådgivning og markedsføring af selskabernes produkter og ydelser. <a href="#" @click.prevent.default="popupP('pop1')">Se mere om disse her</a>. Jeg giver også samtykke til, at Falck ved fremsendelse af elektronisk post må registrere visse data, <a href="#" @click.prevent.default="popupP('pop2')">læs mere her</a>. Du kan til enhver tid tilbagekalde dit samtykke her <a href="falck.dk/afmeld" target="_blank">falck.dk/afmeld</a>. Jeg giver også samtykke til at Falck behandler mine oplysninger i henhold til Falcks privatlivspolitik, <a target="_blank" href="https://www.falck.dk/om-falck/kontakt/cookies/persondatapolitik/">læs mere her</a>
    </label>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  props: {
    linkRed: {
      type: Boolean
    }
  },
  methods: {
    popupP(what){
      console.log(what);
      this.$store.state.global.whatPop = what;
    }
  }
}
</script>

<style lang="scss" scoped>
.isRed label a {
  color: #BC171D;
  text-decoration: underline;
}
input:checked + .isRed label:before {
  background-color: #666;
}
.isRed label:before {
  border: 2px solid #666;
}
</style>



// WEBPACK FOOTER //
// src/components/modular/PermissionText.vue